import cn from 'classnames'
import React from 'react'
import { collisionLabelTextForUsers } from 'util/agents'
import styles from './styles.less'

export default function AgentViewingCollision({ viewingAgents, className }) {
  const label = collisionLabelTextForUsers(viewingAgents, 'viewing')
  return (
    <div
      className={cn(
        styles.mx_MessageComposer_collision,
        'mx_MessageComposer_collision',
        className,
        {
          [styles.visible]: viewingAgents.length > 0,
        }
      )}
    >
      {label && `${label}...`}
    </div>
  )
}
